/**
 * 카드 alias("[KB국민] 1234")에서 카드사명("[KB국민]") 추출.
 *
 * 백엔드가 카드사명 별도 필드를 안 줘서 alias 앞부분 대괄호로 파싱.
 * 시안(19008-11669): 카드 상단 가운데에 카드사명, 하단 좌측에 alias 전체.
 * 대괄호가 없으면 원본 그대로 반환.
 */
export function extractCardIssuer(alias: string): string {
  const match = alias.match(/^\[[^\]]*\]/)
  return match ? match[0] : alias
}
